import * as React from "react";
import { forwardRef } from "react";
const DiscoverIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "discover-icon_svg__a",
  width: 42,
  height: 27,
  x: 3,
  y: 11,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.5932 24.3157c0 7.1017-5.7569 12.8584-12.8586 12.8584H4.37143c-.50411 0-.91429-.41-.91429-.9143V12.3714c0-.5042.41018-.9143.91429-.9143H29.7346c7.1017 0 12.8586 5.7568 12.8586 12.8586M43.2707 11H4.37143C3.61393 11 3 11.6139 3 12.3714v23.8884c0 .7575.61393 1.3714 1.37143 1.3714H43.2707c.7573 0 1.3715-.6139 1.3715-1.3714V12.3714c0-.7575-.6142-1.3714-1.3715-1.3714"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#discover-icon_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "discover-icon_svg__b",
  width: 50,
  height: 51,
  x: -1,
  y: -1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.5243 24.3157c0 13.6426-11.0597 24.7023-24.7023 24.7023-13.6429 0-24.702524-11.0597-24.702524-24.7023C-.880524 10.6727 10.1791-.386978 23.822-.386978c13.6426 0 24.7023 11.059678 24.7023 24.702678"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#discover-icon_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E2421B",
  d: "M14.7802 58.0596-9.92215 15.2738 32.8636-9.42835 57.5659 33.3575z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2431B",
  d: "M15.2279 58.835-9.47446 16.0491 33.3113-8.65304 58.0135 34.1328z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3441B",
  d: "M15.6755 59.6103-9.02679 16.8245 33.7589-7.87772 58.4615 34.9081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3451B",
  d: "M16.1232 60.386-8.5791 17.6002 34.2066-7.10241 58.909 35.6834z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4461A",
  d: "M16.5709 61.1614-8.13144 18.3755 34.6543-6.32663 59.3566 36.4589z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4471A",
  d: "m17.0186 61.9368-24.70235-42.786L35.1019-5.55132 59.8046 37.2342z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5471A",
  d: "M17.4662 62.7119-7.23608 19.9262 35.5496-4.77601 60.2521 38.0096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5481A",
  d: "M17.9139 63.4873-6.78839 20.7015 35.9973-4.00069 60.6996 38.7851z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5491A",
  d: "M18.3616 64.263-6.3407 21.4772 36.445-3.2254l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E64A1A",
  d: "M18.8093 65.0383-5.89304 22.2526 36.8927-2.45007 61.5952 40.3358z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E64B1A",
  d: "M19.257 65.8137-5.44534 23.0279 37.3403-1.67431 62.0427 41.1112z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E74C1A",
  d: "M19.7046 66.5891-4.99768 23.8032 37.788-.898987 62.4903 41.8866z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E74D1A",
  d: "M20.1523 67.3642-4.54999 24.5785 38.2357-.12368 62.9383 42.6621z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E74D1A",
  d: "M20.6 68.1396-4.10229 25.3543 38.6834.651634 63.3858 43.4375z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E84E1A",
  d: "M21.0477 68.9155-3.65463 26.1296 39.1311 1.42696 63.8334 44.2128z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E84F1A",
  d: "M21.4954 69.6907-3.20694 26.9049 39.5788 2.20227 64.2809 44.9882z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E95019",
  d: "M21.943 70.466-2.75928 27.6802 40.0264 2.97758 64.7289 45.7637z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E95119",
  d: "M22.3907 71.2414-2.31158 28.4555 40.4741 3.75336 65.1765 46.539z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E95219",
  d: "m22.8384 72.0168-24.70232-42.786L40.9218 4.52866 65.624 47.3144z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA5319",
  d: "M23.2861 72.7919-1.41644 30.0061 41.3694 5.30398 66.072 48.0898z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA5419",
  d: "M23.7338 73.5678-.96875 30.7819 41.8171 6.07931 66.5195 48.8651z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB5519",
  d: "M24.1815 74.343-.521057 31.5572 42.2648 6.85459 66.9671 49.6406z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB5619",
  d: "M24.6291 75.1183-.0733948 32.3326 42.7125 7.63039 67.4146 50.416z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC5719",
  d: "M25.0768 75.8937.374298 33.1078 43.1602 8.40568 67.8626 51.1914z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC5719",
  d: "M25.5245 76.6691.82196 33.8832 43.6079 9.18103 68.3102 51.9668z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC5819",
  d: "M25.6904 76.9565.988037 34.1707 43.7738 9.46854 68.4761 52.2542z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC5919",
  d: "M25.8562 77.244 1.15393 34.4583 43.9397 9.75563 68.6421 52.5417z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EC5A18",
  d: "M26.0223 77.5316 1.31982 34.7458 44.1057 10.0432 68.808 52.8291z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5B19",
  d: "M26.1882 77.8192 1.4859 35.0334l42.7857-24.7027L68.974 53.1166z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5C18",
  d: "M26.3541 78.1062 1.65179 35.3204 44.4375 10.6183 69.1399 53.404z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5C18",
  d: "M26.5202 78.3939 1.81769 35.608 44.6036 10.9058l24.7022 42.7856z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5D18",
  d: "M26.6861 78.6814 1.98373 35.8955 44.7694 11.1933l24.7023 42.7855z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5E18",
  d: "M26.8521 78.9689 2.14963 36.183 44.9355 11.4804l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED5F18",
  d: "M27.0181 79.256 2.3157 36.4705 45.1014 11.768l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED6018",
  d: "M27.1839 79.5435 2.4816 36.7578l42.7857-24.7023 24.7023 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6118",
  d: "M27.35 79.831 2.64749 37.0453 45.4334 12.3431l24.7021 42.7856z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6218",
  d: "M27.5159 80.1185 2.81357 37.3328 45.5993 12.6302 70.3015 55.416z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6218",
  d: "M27.6818 80.4062 2.97946 37.6201 45.7652 12.9177l24.7022 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6318",
  d: "M27.8479 80.6932 3.14536 37.9077 45.9312 13.2052 70.6334 55.991z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6418",
  d: "M28.0138 80.9808 3.31143 38.1949 46.0971 13.4928l24.7022 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EE6517",
  d: "M28.1797 81.2683 3.47733 38.4824 46.263 13.7803l24.7023 42.7855z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6617",
  d: "M28.3457 81.5558 3.64322 38.77 46.4291 14.0674l24.7021 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6717",
  d: "M28.5116 81.843 3.8093 39.0574 46.595 14.3549l24.7026 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6817",
  d: "M28.6775 82.1305 3.97519 39.3448 46.7609 14.6425l24.7027 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6817",
  d: "M28.8436 82.418 4.14108 39.6322 46.927 14.93l24.7025 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6917",
  d: "M29.0094 82.7055 4.30713 39.9197 47.0928 15.2171 71.7954 58.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6A17",
  d: "M29.1755 82.9932 4.47302 40.2071 47.2587 15.5047l24.7027 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6B17",
  d: "M29.3414 83.2801 4.63892 40.4946 47.4248 15.7922 72.1273 58.578z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F06C17",
  d: "M29.5073 83.5678 4.80499 40.7821 47.5907 16.0798l24.7026 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F06D17",
  d: "M29.6732 83.8553 4.97089 41.0694 47.7568 16.3673l24.7024 42.7853z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F06E17",
  d: "M29.8393 84.1428 5.13678 41.3569 47.9227 16.6544l24.7024 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F06E17",
  d: "M30.0052 84.4303 5.30286 41.6444 48.0886 16.9419l24.7025 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F06F17",
  d: "M30.1711 84.7174 5.46875 41.9317 48.2544 17.2294 72.957 60.0153z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F07016",
  d: "M30.3371 85.0049 5.63483 42.2192 48.4205 17.517 73.123 60.3028z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17116",
  d: "M30.503 85.2926 5.80072 42.5067 48.5864 17.8041 73.2889 60.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17216",
  d: "M30.6691 85.5801 5.96661 42.7942 48.7522 18.0917l24.7027 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17316",
  d: "M30.835 85.8671 6.13266 43.0816 48.9182 18.3792 73.6208 61.165z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17416",
  d: "M31.0009 86.1548 6.29858 43.3691 49.0841 18.6667l24.7027 42.786z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17416",
  d: "M31.167 86.4423 6.46448 43.6566 49.2505 18.9543l24.7022 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F17516",
  d: "M31.3328 86.7298 6.63052 43.9439 49.4164 19.2414l24.7022 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27616",
  d: "M31.4987 87.0172 6.79642 44.2314 49.5824 19.5289l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27716",
  d: "M31.6648 87.3044 6.96231 44.5189 49.7483 19.8164l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27816",
  d: "M31.8307 87.5919 7.12839 44.8062 49.9143 20.104l24.7021 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27916",
  d: "M31.9966 87.8796 7.29428 45.0937 50.0802 20.3915l24.7022 42.7854z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27A16",
  d: "M32.1627 88.1671 7.46017 45.3812 50.2462 20.6786l24.7021 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27B16",
  d: "M32.3286 88.4541 7.62625 45.6685 50.4121 20.9662l24.7022 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F27B15",
  d: "M32.4945 88.7417 7.79214 45.956 50.5781 21.2537l24.7021 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F37C15",
  d: "M32.6605 89.0292 7.95822 46.2435 50.744 21.5412l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F37D15",
  d: "M32.8264 89.3167 8.12411 46.5309 50.9099 21.8283l24.7022 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F37E15",
  d: "M32.9925 89.6042 8.29001 46.8183 51.0759 22.1159 75.778 64.9017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F37F15",
  d: "M33.1584 89.8914 8.45609 47.1059 51.2418 22.4034 75.944 65.1892z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F38015",
  d: "M33.3243 90.1789 8.62195 47.3932 51.4078 22.691l24.7021 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F38115",
  d: "M33.4904 90.4665 8.78784 47.6807 51.5737 22.9785l24.7022 42.7854z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48215",
  d: "M33.6562 90.754 8.95374 47.9682 51.7397 23.2656l24.7021 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48215",
  d: "M33.8221 91.041 9.11981 48.2555 51.9056 23.5531l24.7022 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48315",
  d: "M33.9882 91.3287 9.28571 48.543 52.0715 23.8407l24.7022 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48415",
  d: "M34.1541 91.6162 9.45178 48.8305 52.2375 24.1282 76.9397 66.914z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48515",
  d: "M34.32 91.9037 9.61768 49.118 52.4034 24.4153l24.7022 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F48615",
  d: "M34.4861 92.1912 9.7836 49.4053l42.7858-24.7025L77.272 67.4887z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58715",
  d: "M34.652 92.4783 9.94962 49.6928 52.7353 24.9904l24.7026 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58814",
  d: "M34.8179 92.7658 10.1155 49.9803l42.7857-24.7024 24.7027 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58914",
  d: "M34.9839 93.0535 10.2814 50.2676l42.7858-24.7021 24.7026 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58A14",
  d: "M35.1498 93.341 10.4475 50.5551 53.2332 25.853l24.7026 42.7853z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58A14",
  d: "M35.3157 93.6285 10.6134 50.8426l42.7857-24.7025 24.7026 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58B14",
  d: "M35.4818 93.9157 10.7793 51.13 53.565 26.4276l24.7027 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F58C14",
  d: "M35.6477 94.2032 10.9454 51.4174 53.731 26.7152 78.4336 69.501z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F68D14",
  d: "M35.8138 94.4907 11.1113 51.7049l42.7856-24.7026 24.7026 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F68E14",
  d: "M35.9797 94.7784 11.2772 51.9922l42.7857-24.7024 24.7026 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F68F14",
  d: "M36.1456 95.0653 11.4432 52.2798l42.7856-24.7024 24.7026 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F69014",
  d: "M36.3115 95.3528 11.6091 52.5673l42.7856-24.7024 24.7027 42.7858z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F69114",
  d: "M36.4775 95.6405 11.775 52.8546l42.7857-24.7022 24.7026 42.786z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F69114",
  d: "M36.6434 95.928 11.9411 53.1421 54.7266 28.44l24.7027 42.7853z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79214",
  d: "M36.8093 96.2155 12.107 53.4296l42.7856-24.7025 24.7026 42.7857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79314",
  d: "M36.9753 96.5026 12.273 53.7169l42.7855-24.7023 24.7026 42.7859z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79413",
  d: "M37.1412 96.7902 12.4389 54.0044l42.786-24.7022L79.9271 72.088z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79513",
  d: "M37.3073 97.0776 12.6048 54.2919l42.7861-24.7027L80.093 72.3751z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79613",
  d: "M37.4732 97.3653 12.7709 54.5792l42.7859-24.7024L80.259 72.6626z"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.45715 12.3714v23.8884c0 .5041.41018.9143.91429.9143H29.7346c7.1017 0 12.8586-5.7567 12.8586-12.8585 0-7.1017-5.7569-12.8585-12.8586-12.8585H4.37144c-.50411 0-.91429.4101-.91429.9143"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M7.8373 25.6775c-.34677.3131-.79749.4498-1.51034.4498h-.29643v-3.7422h.29643c.71285 0 1.14571.1276 1.51034.4576.38198.3401.6111.8663.6111 1.4085 0 .5435-.22912 1.0866-.6111 1.4263M6.54803 21.426H4.92767v5.6594h1.61161c.85696 0 1.47607-.202 2.0193-.6537.64553-.5344 1.02715-1.3394 1.02715-2.1718 0-1.6704-1.24768-2.8339-3.0377-2.8339m3.54587 5.6594h1.1036V21.426h-1.1036zm3.8027-3.4874c-.6625-.2455-.857-.4069-.857-.7127 0-.3566.3466-.6272.8224-.6272.3309 0 .6025.1358.8901.4585l.5777-.7565c-.4748-.4151-1.0427-.6272-1.6628-.6272-1.0014 0-1.7652.6953-1.7652 1.6214 0 .7795.3557 1.1786 1.3925 1.5516.4318.1527.6518.2542.7629.3227.2203.1436.331.3475.331.5852 0 .4585-.3646.7981-.8573.7981-.5261 0-.9504-.2628-1.2044-.7542l-.7133.6861c.5086.7465 1.1193 1.0775 1.9593 1.0775 1.1471 0 1.952-.7625 1.952-1.8578 0-.8997-.372-1.3065-1.6279-1.7655m1.9759.6618c0 1.6631 1.3062 2.9527 2.9872 2.9527.4749 0 .8817-.0932 1.3837-.3291v-1.2997c-.4414.4416-.8323.6195-1.3327.6195-1.1118 0-1.9007-.806-1.9007-1.952 0-1.0862.8143-1.9434 1.8497-1.9434.5262 0 .9251.1879 1.3837.6368v-1.2987c-.4845-.2459-.8829-.3474-1.3579-.3474-1.6721 0-3.013 1.3156-3.013 2.9613m13.1232.9674L27.486 21.426h-1.2055l2.4014 5.8048h.5941l2.4449-5.8048h-1.1968zm3.224 1.8582h3.1307v-.9581H33.323v-1.5278h1.9522v-.9586H33.323v-1.2558h2.0274v-.9591h-3.1307zm5.2869-3.0537h-.323v-1.7142h.34c.6878 0 1.0616.288 1.0616.8388 0 .5692-.3738.8754-1.0786.8754m2.2148-.9348c0-1.0597-.7303-1.6709-2.0034-1.6709h-1.6366v5.6594h1.1022v-2.2733h.1445l1.5278 2.2733h1.3573l-1.7817-2.3844c.8317-.1692 1.2899-.7374 1.2899-1.6041m.6695-1.3061h-.0204v-.1302h.0216c.0588 0 .0895.021.0895.064 0 .0443-.0311.0662-.0907.0662m.21-.0676c0-.0997-.0688-.1541-.1891-.1541h-.16v.4988h.1187v-.1934l.1396.1934h.1456l-.1639-.2057c.0698-.0188.1091-.07.1091-.139"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M40.4339 22.1753c-.1907 0-.3466-.159-.3466-.357 0-.1988.1545-.3575.3466-.3575.19 0 .3445.1623.3445.3575 0 .1961-.1545.357-.3445.357m.0018-.7926c-.2422 0-.4347.1933-.4347.4347 0 .2418.1947.4357.4347.4357.2361 0 .4297-.1962.4297-.4357 0-.2382-.1936-.4347-.4297-.4347"
}), /*#__PURE__*/React.createElement("mask", {
  id: "discover-icon_svg__c",
  width: 7,
  height: 7,
  x: 20,
  y: 21,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M23.596 27.2473c-1.6539 0-2.9951-1.3412-2.9951-2.9952v-.0041c0-.8229.3332-1.5717.8723-2.1106 0-.0041.0041-.0041.0041-.0083.0041 0 .0041-.0041.0082-.0041.5389-.5389 1.2877-.8722 2.1105-.8722h.0042c1.6539 0 2.9951 1.3413 2.9951 2.9952v.0041c0 .8229-.3332 1.5676-.8721 2.1106 0 .0042-.0041.0042-.0041.0083-.0041 0-.0041.0041-.0082.0041-.5431.539-1.2879.8722-2.1107.8722z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#discover-icon_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#discover-icon_svg__d)",
  d: "M20.4125 21.0704h6.40914v6.40914H20.4125z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "discover-icon_svg__d",
  width: 1,
  height: 1,
  patternContentUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#discover-icon_svg__e",
  transform: "scale(.01724)"
})), /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAABHNCSVQICAgIfAhkiAAACfNJREFUaIHlm02PXEcVhp9TdW93jx0LFo49ExwrSGjMD2AZsUAoa9ZICCkSASFAmE0kEBILrNgsWPEr+A38AMRHEIkAIUVKCIkTycGWE489Tnffw6K+TtW93Z4Zz4QFV2q17+3qe+up961zTtW0RVWV/4OjO8ubv7a/ixfBAQI4GbcZ0kvh1X9+cGZ9kdNU9Mb+Lr0InUAnghfwgBdwyCQoJFBlDawUlqpc/8fpQp8K6M39PXqBmRN6CWA9AdgL+AgvlBfxXQWUoOgaWKuyVFgCh4PyeDg+9Jde+OLo2lOB3tzfY+ZgJsLMQS9CT3ifOaKy4CO0AySqjFE3gSbYFUHVpcKhKg/X8HBQfvT3258t6I39XeYizJ0wdzAXYSYRUMjwnYQg0Ecbdw6cKOLiwyOsaqBVFdYK66joUpXDAR4PyoHCg7Xy8pvvnwj22KC3ru0xd7AQibDk91kClfDv3oH3SufBuwAoLgA66990qIIIOsB6gGEQlkvh0Soo+2BQPlnDvfXAK29uV/fEoO++9AV++6+BuRMWEW6RgA3sXIRZV+BcB94BojgpkEpUNIImddE4dyP3MMCgwmoJjw4dn6yV+wPcXQ5886+b1T0R6I39XRZOwksC3I4voAuBhSuAfaf4rsC5xqpWRTHnhjW216qhRoUfHjjuLpU7K+Ubr793JNgngt7Y381gOyLsREXT+0KEhVfmPXQR1HlFonpirXlCwCorxfPlSrh7z/PhWnnpD/9+OtBf7u+y48S84FxSU8K/5zMNSnYB0LszBDSOSAHt8JHj3XvCi7/fDus2QUK0aAN5zgvnBZ5xwmKuLGbKbGbUdI1FDVSak+lyDLaIaIFMTrCMznw3BrR0k8X5gf0ra/784vPbUDaD/uraXp6XFvKcwHkv7MyVxVzpOsV7xfszAnQNoIHEKeIU8crVKyve+OrV44G+dm03pBBHFXwS5Hym9DOl89Gy6S6nBSgN4ERJlaeHGYTnrixHLG+98/Zm0FkuBpKiwo7Ajhfmc2U20xBZ/bgTpwZoQKyKAUrBKWTFJbf7z7f2ppDGq5db1/Y472IxIMG2Ow7OOWExU/o+QGYrlUE+WZBJA5NHacMUyAMaAa3CTit12+Otd94eK5pKuIUEwFAYCLM+RleviC83tAqm82MpaFSbUjGrHFWsgpGj9CVfV+69vDuCrRS9dW2PZ3yxbap+djzMe6XrQ2TNqjRpwwLaD7YqaAeqmYMQAdN5EwuszSFa2rYzR3UpFOPlFQKS0M+UvifMycY21qZHVtB+biFt8GkVtCq6GlJi9A2L39Dm3vcuV6BZ0deu7XLBO3qRbNeFE+ZdDDxOcd50mhMoaADzTdp56cK9bK60baW1NFoNQrqHNJ3IoL1IXDyHVx/V7Tti1fOUgKnzmwBjoGkVrtqZYFPZ1AQqaaETeyYWoXcS15Qx6vYhynqnoeLhBBaFOkKbwFECT0z8rnxep5MSdFKBQNNWfPy+L23v/7jYNyuaFsll4UxYasWyLgNuU2zqPFty4lo7R93E9RSNW5vaQRLASZnbE4p2ALe+vMfnvNBFy/YC87jcyhP9pICN9WoQrTsNlfWyXW27DFpsKk5I+TUNara2BfVC3rnrCPb1XVw02wB0FEADN5qDCQRKx1rAJuBkFS1gHgiJCmpwXB4cU1RYUCfgROgI+zq9xAAU5+KxAdO1VqkEaKwljRUrm6Z2TduSbmrApOJUQHIQdunCtmTczHJhG6RakTARZNo5ZhVpVx0S69OY50YVjmvampyYg5DToIoP26S2MhJbseWX8uDnzxZFRcpGcych+DjfqLNJ0Q0qVrVpOwg07azlzDxM18QVsNTGFhaj4j9eU8i7cF1+ZlTUO6H3wbLezKFJQFoo828oEXB0vfmOmxiMeF2JyqbvmUFpbZ8gw7vEIKYFNEE44t9JYlpJjVpFx9VMZGjnoZ0v7aA4SjR19WfiNCoo2MCSbD21fEsV1SgKx2fnYGRVtecjQIz9tgG287YCnB4MEdCq4tHqs1Z5BPATgJuiLlAPkAsTeyNgC2Ig2xp1lBdNNLVlnVoFms9yLq0UpDguKdNMFXFw7qd3CuiQ+tooemxAymfjtNGondNGA2jzaVLR3ttOqS2ANrZk0FCkS7lZgoLR/CkwWwDb72Gs1FQ2GueIVBZM75sqIqn6UH+n7k8FulZlQDOsHclRnmxVbAEnVGx373I0tXnzKICS7LYBMFWqzfRJl7j+tw9Ya7BwUlFsB83DiPNX2sRPaZuSu21HSuppADuiDcntJlcmafHtJQQep+Y5lHQDucCo+mwVhfA3yQFYW3s20XQcOWsVU/FflWAbFWoUbCwfkn6adKUP9WqmdlC71TIJulRlhbJGsq1GgG0wqmzbJHBTubSQteV11NlqC7MBnOxDG3zi+bnrd6pLAHz3jds8VlihZgeBHECm9m7ycsgsmstCubaZXRBnG/vNn+doauy5qQ8Z0vbBgtPsAj5W5VOEYZDSoQ2jl+tM7HmjoESA1gEpwrYKZ/vWTmqrK6bOae1cr6Er0INBORyU1VpCXm9yYVvVWMWzAs3I2tG2y6i0vGojax0LhNGiG/PeWtkM0s4PP6pAnT35zl9uczDA4VpYDaXDWHXjyiDt44RIp0XJzlgwdaTTsqeTrYtZijVbm15yFK4s2sSA2g0aonICb47RnyTuD+G3Ap9fOVTX4YF2tK2dm0BTFwSNgnb0Xf39Ym2J51M7fPWr3msqNhWBxQ9qNUeKAnz7j+9zf618+jjcJQeb9LfPHDxMNEwKjnJmOpfyeW5TnBG3OMrieiofmvla9SGltNbCzbHxL96vf+15nru8ZnFhyAHHppwpBdPSKykoTti251MpiGlT5e/Q8zpelI2vdhtn8f2xmrDlt4AfrpSLjxw7Fwa0yYltvkw2TUEmB5Fm67F8T4q1LWAFkhyFabMZEDZDhjHb8huGP339Ci9cXdPvDPlh1cpjNBelUrwG1DFgM1ghJaQ2Rwd8EmS6zcbjK797j0cf+/DgVLd2pWMp6YuTWNNqTv6lVEsBS6oUk9ul+RgHoorYXhmlMjswxziO9Dujj17ZZXa+XTFoCSTNPCxRWqq5O4qeDmJGLQt9G0VtqtgSaJ6k5pFBAT7+yeXQmRRMvAEcpY4NNm2DDRpWJRYkL6rNw7f47iiQcAxQgAevXjLRUmsFkzrWogmgmm+hXVk8c6aA6Tj2jx4f/OzSBgXJubDqaDOnwhyV8jnl+3ZXcdtxXMjwiBP+XvfgF5eyOiHhsyUfHhFwyzxMx0kgw6Oe8hfYBzcu1YDp3aYeqCHbdHGGgOk4td/UP7z57IRFGatoSjaskhuOpwVMx6n+54F0PPr1xe2A8NTp4rjHmYBOHYe/uRifSPV+FlBTx2cG+r8+/gu/IAgJSmSNNQAAAABJRU5ErkJggg==",
  id: "discover-icon_svg__e",
  width: 58,
  height: 58
})));
const ForwardRef = forwardRef(DiscoverIcon);
export { ForwardRef as DiscoverIcon };